import React from "react";
import GoogleChart from "../../../../../components/googleChart/googleChart";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { actionCreators } from "../redux/IntroductoryOfferSagas";

const IntroductoryOfferChart = () => {
  const dispatch = useDispatch();

  const { chartData: { data_table: { cols = [], rows = [] } = {}, options } = {}, table_view } =
    useSelector((state) => {
      const {
        chartData,
        selectedFilters: { table_view }
      } = state.IntroductoryOffer;
      return {
        chartData,
        table_view
      };
    }, shallowEqual);

  const switchView = (view) => dispatch(actionCreators.updateTableView(view));

  return (
    <GoogleChart
      chartName="intro_retention_chart"
      width="1350px"
      height={400}
      chartType={table_view ? "Table" : "BarChart"}
      isTableView={table_view}
      enableEventListeners={true}
      showAdditionTooltip={false}
      rows={rows}
      columns={cols}
      options={options}
      switchView={switchView}
    />
  );
};

export default IntroductoryOfferChart;
